import { render } from "./FtsCustoms.vue?vue&type=template&id=0b93ee2a"
import script from "./FtsCustoms.vue?vue&type=script&lang=js"
export * from "./FtsCustoms.vue?vue&type=script&lang=js"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__